import AuthRoutes from '@/router/modules/auth'
import HomeRoutes from '@/router/modules/home'
import CartRoutes from '@/router/modules/carts'
import MenuRoutes from '@/router/modules/menu'
import ProjectRoutes from '@/router/modules/projects'
import ProjectNomination from '@/router/modules/projectNomination'
import VolunteerRequest from '@/router/modules/volunteerRequest'
import DonationVouchers from '@/router/modules/donationVouchers'
import NewsRoutes from '@/router/modules/news'
import AboutRoutes from '@/router/modules/about'
import ContactRoutes from '@/router/modules/contacts'
import PagesRoutes from '@/router/modules/pages'
import AchievementsRoutes from '@/router/modules/achievements'
import ErrorsRoutes from '@/router/modules/errors'

// Dynamically extract all known first-level route slugs from existing route modules
const allKnownRoutes = [].concat(
    AuthRoutes, HomeRoutes, CartRoutes, MenuRoutes,
    ProjectRoutes, ProjectNomination, VolunteerRequest,
    DonationVouchers, NewsRoutes, AboutRoutes,
    ContactRoutes, PagesRoutes, AchievementsRoutes, ErrorsRoutes
)

const KNOWN_SLUGS = [...new Set(
    allKnownRoutes
        .map(r => r.path)
        .filter(p => p && p !== '/' && p !== '*')
        .map(p => p.replace(/^\//, '').split('/')[0])
        .filter(Boolean)
)]

export default [
    {
        path: '/:code',
        name: 'share-redirect',
        component: () => import('@/views/pages/ShareRedirect.vue'),
        beforeEnter(to, from, next) {
            if (KNOWN_SLUGS.includes(to.params.code)) {
                // Code matches a known top-level route — let Vue Router's regular matching or 404 handle it
                next({ name: '404' })
            } else {
                // Unknown slug/code — proceed to ShareRedirect page
                next()
            }
        },
    },
]
